<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-pencil
        </v-icon>Update Status
      </h2>
      <p
        class="p-style"
      >
        <v-icon color="#37474F">
          mdi-information-outline
        </v-icon>
        Update Settings Fault Status.
      </p>
      <v-form>
        <v-card-text class="text-body-1 text-center">
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              cols="12"
              md="8"
              sm="8"
            >
              <v-select
                v-model="statusValue"
                label="Fault Status*"
                dense
                outlined
                :items="statusValues"
              />
            </v-col>
          </v-row>
          <br>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="mt-2"
            color="red darken-3"
            @click="showModal = false"
          >
            cancel
          </v-btn>
          <v-spacer />
          <v-btn
            class="mt-2"
            color="#FF3700"
            @click="update()"
          >
            update
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'UpdateSettingsFaultStatus',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      settingsFaultStatus: {
        type: String,
        required: true,
      },
      settingsFaultId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        showModal: true,
        statusValues: ['pending', 'completed'],
        statusValue: '',
        loading: false,
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.loading = true;
      this.statusValue = this.settingsFaultStatus;
      this.loading = false;
    },
    methods: {
      update () {
        this.loading = true;
        this.$store.dispatch('settings/updateSettingsFaultStatus', {
          status: this.statusValue,
          id: this.settingsFaultId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Settings fault status updated successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$emit('success');
          this.loading = false;
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.p-style {
  font-size: 18px;
  font-weight: bold;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-align: center;
  background-color: #CFD8DC;
  font-style: italic;
  margin-top: 20px;
}
</style>
